import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "topBar"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  key: 0,
  class: "pallinoNotifiche inAppNotifications"
}
const _hoisted_5 = {
  key: 1,
  class: "topBar"
}
const _hoisted_6 = { class: "backButton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_burger = _resolveComponent("icon-burger")!
  const _component_icon_bell = _resolveComponent("icon-bell")!
  const _component_icon_chevron_left = _resolveComponent("icon-chevron-left")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.meta.hasBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLeftMenu = !_ctx.showLeftMenu))
            }, [
              _createVNode(_component_icon_burger)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.openInAppNotificationsModal()))
            }, [
              _createVNode(_component_icon_bell, {
                class: _normalizeClass({ shaking: _ctx.$store.state.inAppNotificationsCount > 0 })
              }, null, 8, ["class"])
            ]),
            (_ctx.$store.state.inAppNotificationsCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-link",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
            }, [
              _createVNode(_component_icon_chevron_left)
            ])
          ])
        ])),
    (_ctx.showLeftMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "leftMenu",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLeftMenu = false))
        }, [
          _createElementVNode("button", {
            class: "leftMenuItem text-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToAreaSoci && _ctx.goToAreaSoci(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Area soci",
              text: "Area soci"
            })
          ]),
          _createVNode(_component_router_link, {
            to: "/villages/villageList",
            class: "leftMenuItem text-white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLastSoci(false)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_localized_text, {
                localizedKey: "Strutture",
                text: "Strutture"
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}